import CamelCaseTransform from 'cio/transforms/camel-case';
import { CampaignType } from 'cio/models/campaign';
import { SegmentUsage } from 'cio/utils/segment-usage';

interface SerializedSegmentUsageItem {
  id: string;
  name: string;
  type: CampaignType | 'newsletter' | 'sql_import';
  updated: number;
  recipients?: boolean;
  trigger?: boolean;
  filter?: boolean;
  static_seg_updates?: boolean;
  archived?: boolean;
}

interface SerializedSegmentUsage {
  draft_newsletters: SerializedSegmentUsageItem[];
  sent_newsletters: SerializedSegmentUsageItem[];
  campaigns: SerializedSegmentUsageItem[];
  broadcasts: SerializedSegmentUsageItem[];
  sql_imports: SerializedSegmentUsageItem[];
  dashboard: number[];
}

export default class SegmentUsageTransform extends CamelCaseTransform {
  deserialize(serialized: SerializedSegmentUsage | null, options: any) {
    let deserialized = super.deserialize(serialized, { ...options, recursive: true });

    if (deserialized == null) {
      return null;
    }

    deserialized.newsletters = [...(deserialized.sentNewsletters ?? []), ...(deserialized.draftNewsletters ?? [])];
    return deserialized;
  }

  serialize(deserialized: SegmentUsage | null, options: any) {
    let serialized = super.serialize(deserialized, { ...options, recursive: true });

    if (serialized == null) {
      return null;
    }

    delete serialized.newsletters;
    return serialized;
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'segment/usage': SegmentUsage | null;
  }
}
